<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center w-100">

                <!-- "> md" -->
                <img src="../../../assets/images/banners/manufacturing-banner.png"
                    class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="manufacturing-banner" />

                <!-- "<= md" -->
                <img src="../../../assets/images/banners/manufacture-mobile-banner.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="manufacture-mobile-banner" />

                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-9 col-md-5 col-sm-12 col-xs-12 col-lg-5 banner-section">
                            <p class="cloud-tagline text-white ">MANUFACTURING</p>

                            <div class="align-items-center banner-content-title  global_title global_banner_title"
                                role="heading" aria-level="1">
                                <span>The future of manufacturing is here. Are you in?</span>

                            </div>
                            <div class="global_sub_title global_banner_subtitle manufacturesubtitle mt-3">
                                <span>Transform your operations with next-level technologies. </span>
                            </div>
                            <div class="col pt-lg-3 pt-2 mt-lg-2">

                                <a href="contact" class="global_button  text-left col text-white white_button"
                                    role="button" aria-label="View Contact Page" tabindex="0">
                                    <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                            alt="arrow white" /></div>
                                    MAKE THE LEAP FORWARD
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="laptop_bg_image">
    <div class="container pt-5">
        <div class="row">

            <div class="col-lg-1  col-sm-12"></div>

            <div class="col-lg-10 col-sm-12">
                <div class="mobile_content_service global_section_header pt-5">

                    Prepare for the Fourth Industrial Revolution with Technology
                </div>
                <div class="mobile_service-subcontent global_section_content pt-3">

                    <p>In order to compete in a digitally disrupted environment, industrial businesses must become more
                        agile and increase production efficiency. Fortunately, PE&IM enterprises can harness
                        cutting-edge technologies like robotics, 3D printing, the Internet of Things (IoT), and
                        predictive maintenance to create effective value chains and data-driven factory that maximizes
                        ROI and enables greater performance. </p>
                    <p>Maganti IT helps PEIM firms foster innovation and shorten time-to-market by utilizing its
                        extensive domain expertise in manufacturing technology solutions. We analyze market gaps and
                        bridge it with tailored IT solutions that provide the best value possible. </p>


                </div>
            </div>
            <div class="col-lg-1  col-sm-12"></div>
        </div>
    </div>
</div>

<br>

<!--------------- SERVICE OFFERINGS STARTS HERE ------->

<!--======== Ourcompany tabs starts ======== -->

<div class=" section-space--ptb_90">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-sm-12">
                <div class="section-title-wrapper text-center section-space--mb_60 wow move-up">
                    <div class="section-title">Modernizing Manufacturing one process at a Time </div>
                </div>
            </div>

            <div class="ourcompany_maintabs">
                <div class="companytablinks" (click)="openCity('ourtabmission')"
                    [class.active]="activeTab === 'ourtabmission'" tabindex="0">
                    <div class="ourcompany_subtabs" role="button" aria-haspopup="true" tabindex="0">Data and Analytics
                    </div>
                </div>

                <div class="companytablinks" (click)="openCity('ourtabservices')"
                    [class.active]="activeTab === 'ourtabservices'" tabindex="0">
                    <div class="ourcompany_subtabs " role="button" aria-haspopup="true" tabindex="0">AI and Automation
                    </div>
                </div>

                <div class="companytablinks" (click)="openCity('ourtabtechnology')"
                    [class.active]="activeTab === 'ourtabtechnology'" tabindex="0">
                    <div class="ourcompany_subtabs" role="button" aria-haspopup="true" tabindex="0">Cloud Computing &
                        Lean Processes </div>
                </div>

                <div class="companytablinks" (click)="openCity('ourtabawards')"
                    [class.active]="activeTab === 'ourtabawards'" tabindex="0">
                    <div class="ourcompany_subtabs" role="button" aria-haspopup="true" tabindex="0">Digital
                        Transformation</div>
                </div>
            </div>

            <!--====== Our company mission Tabs Start ======-->
            <div *ngIf="activeTab === 'ourtabmission'" class="companytabscontent pt-5">
                <div class="row" id="image-cards">
                    <!-- <div class="col-lg-2"></div> -->
                    <div class="col-lg-6">
                        <img src="../../../assets/images/manufacture/analytics.png" alt="analytics"
                            class="img-responsive ourcomapny_mediacontent manufacturing_image">
                    </div>
                    <div class="col-lg-6">
                        <div class="tab-content-inner">
                            <div class="text  global_section_content ourcomapny_mediacontent ">
                                <div class="fw-bold"> Data and Analytics</div>
                            </div>
                            <p
                                class="check-list ourcomapny_tabchecklist ourcomapny_mediacontent section-space--mb_40 global_section_content">
                                Leverage our advanced data and analytics solutions to transform data into useful
                                insights. We focus
                                on areas such as inventory updates, financial transactions, operating system data,
                                process
                                parameters, quality events, and machine data to uncover new insights through advanced
                                analytical
                                tools and technologies.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <!--====== Ourcompany mission Tabs End ======-->
            <!--====== Ourcompany services  Tabs Start ======-->

            <div *ngIf="activeTab === 'ourtabservices'" class="companytabscontent pt-5">
                <div class="row " id="image-cards">
                    <div class="col-lg-6">
                        <img src="../../../assets/images/manufacture/AI.png" alt="Banner mit"
                            class="img-responsive ourcomapny_mediacontent manufacturing_image">
                    </div>
                    <div class="col-lg-6">
                        <div class="tab-content-inner  ">
                            <div class="text  global_section_content ourcomapny_mediacontent">
                                <div class="fw-bold"> AI and Automation</div>
                            </div>
                            <p
                                class="check-list ourcomapny_tabchecklist ourcomapny_mediacontent section-space--mb_40 global_section_content">
                                AI-based technologies have inevitably changed the way goods and services are planned and
                                produced
                                today. It is implemented in case scenarios such as Predictive Maintenance to Forecast
                                The remaining
                                Useful Life of Equipment, Robotic Process Automation to Streamline Paperwork, Quality
                                Assurance &
                                Inspection, Demand Forecasting to Improve Supply Chain Efficiency and warehouse
                                Automation.
                            </p>
                        </div>
                    </div>
                    <!-- <div class="col-lg-1"></div> -->
                </div>
            </div>
            <!--====== Our company mission Tabs End ======-->
            <!-- </mat-tab> -->



            <!-- <mat-tab label="Cloud Computing & Lean Processes">   -->
            <!--====== our company technology  Start ======-->
            <div *ngIf="activeTab === 'ourtabtechnology'" class="companytabscontent pt-5">
                <div class="row" id="image-cards">
                    <!-- <div class="col-lg-2"></div> -->
                    <div class="col-lg-6">
                        <img src="../../../assets/images/manufacture/cloud-computing.png" alt="Banner mit"
                            class="img-responsive ourcomapny_mediacontent manufacturing_image">
                    </div>
                    <div class="col-lg-6">
                        <div class="tab-content-inner  ">
                            <div class="text  global_section_content ourcomapny_mediacontent">
                                <div class="fw-bold"> Cloud computing & lean processes</div>
                            </div>
                            <p
                                class="check-list ourcomapny_tabchecklist ourcomapny_mediacontent section-space--mb_40 global_section_content">
                                Maganti IT combines its DevOps and Cloud expertise to assist clients in scaling up by
                                utilising
                                industry-leading techniques and platforms. To better serve you, we collaborate with
                                renowned cloud
                                service providers like Microsoft Azure, Amazon Web Services, and Google Cloud.
                            </p>
                        </div>
                    </div>
                    <!-- <div class="col-lg-1"></div> -->
                </div>
            </div>

            <!--====== Our company technology End ======-->
            <!-- </mat-tab> -->

            <!--====== our company awards  Start ======-->
            <div *ngIf="activeTab === 'ourtabawards'" class="companytabscontent pt-5">
                <div class="row" id="image-cards">
                    <!-- <div class="col-lg-2"></div> -->
                    <div class="col-lg-6">
                        <img src="../../../assets/images/manufacture/digital-transform.png" alt="digital transform"
                            class="img-responsive ourcomapny_mediacontent manufacturing_image">
                    </div>
                    <div class="col-lg-6">
                        <div class="tab-content-inner  ">
                            <div class="text  global_section_content ourcomapny_mediacontent">
                                <div class="fw-bold"> Digital Transformation </div>
                            </div>
                            <p
                                class="check-list ourcomapny_tabchecklist ourcomapny_mediacontent section-space--mb_40 global_section_content">
                                Digitalization and automation are the gamechangers for mastering the challenges of today
                                and
                                tomorrow. Upgrade your enterprise with next-gen IoT and digital transformation to get
                                ahead in your
                                industry.
                            </p>
                        </div>
                    </div>
                    <!-- <div class="col-lg-1"></div> -->
                </div>
            </div>
            <!--====== Our company awards End ======-->
        </div>
    </div>
</div>



<div class="feature-icon-wrapper  benefits_bgimage section-space--pt_100 section-space--pb_60">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title-wrap text-center section-space--mb_20">
                    <h2 class="manufacture-heading"> Segments We serve </h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="feature-list__three">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">

                                                <i class="fa-solid fa-warehouse"></i>

                                            </div>
                                            <h2 class="heading global_sub_title1">
                                                <b>Warehouse Management</b>
                                            </h2>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">Improve workforce performance,
                                                reduce obsolescence with
                                                our warehouse management solution, which includes real-time transaction
                                                processing, streamlined organisation techniques, directed task
                                                management, and much more.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <i class="fa-solid fa-rotate-right"></i>
                                            </div>
                                            <h2 class="heading global_sub_title1">
                                                <b>Product Lifecycle</b>
                                            </h2>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">With our product lifecycle
                                                management systems, you can
                                                reduce cycle times, improve business procedures, and increase revenue
                                                while increasing market value and customer experience.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">

                                                <i class="fa-solid fa-dolly manufacture_iconimage"></i>
                                            </div>
                                            <h2 class="heading global_sub_title1">
                                                <b>Enterprise & Supply Chain Management</b>
                                            </h2>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">We help enterprises solve critical
                                                supply chain challenges
                                                while saving cost in the most efficient manner with strategy and
                                                Innovation.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <i class="fa-solid fa-pallet manufacture_iconimage"></i>
                                            </div>
                                            <h2 class="heading global_sub_title1">
                                                <b>Order and Inventory Management </b>
                                            </h2>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">We streamline your inventory and
                                                order management
                                                processes ensuring optimized inventory and operational cost and better
                                                efficiency. </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <i class="fa-solid fa-credit-card manufacture_iconimage"></i>
                                            </div>
                                            <h2 class="heading global_sub_title1">
                                                <b>Manufacturing Sales Support</b>
                                            </h2>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">Maganti IT provides market-leading
                                                sales enablement tools
                                                that enable industrial businesses to pursue innovative business
                                                strategies.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="grid-item animate">
                                <div class="ht-box-icon style-03">
                                    <div class="icon-box-wrap">
                                        <div class="content-header">
                                            <div class="icon">
                                                <i class="fas fa-microchip manufacture_iconimage"></i>
                                            </div>
                                            <h2 class="heading global_sub_title1">
                                                <b>Infrastructure Integration Technology</b>
                                            </h2>
                                        </div>
                                        <div class="content">
                                            <div class="text global_section_content">At Maganti IT, we have a holistic
                                                and integrated approach
                                                towards core modernization to experience technological evolution.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!---------------  BENEFITS THAT MATTER ENDS HERE ------->
<div class="feature-large-images-wrapper section-space--pt_60">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <!-- section-title-wrap Start -->
                <div class="section-title-wrap text-center section-space--mb_30">
                    <h2 class="manufacture-heading">Case Studies</h2>
                </div>
            </div>
        </div>

        <div class="row row--35">
            <!-- First Case Study Card -->
            <div class="col-lg-4 col-md-6 col-sm-12 mt-30 d-flex">
                <a href="/futek-casestudy" class="box-large-image__wrap wow move-up w-100"
                    aria-label="Go to futek casestudy">
                    <div class="box-large-image__box">
                        <div class="box-large-image__midea">
                            <div class="images-midea">
                                <img src="../../../assets/images/manufacture/Futek.png" alt="manufacturing futek">
                                <div class="button-wrapper">
                                    <div class="btn tm-button">
                                        <span class="industries_button-text">Learn more</span>
                                    </div>
                                </div>
                                <div class="heading-wrap">
                                    <h3 class="heading">FUTEK</h3>
                                </div>
                            </div>
                        </div>
                        <div class="mt-30 text-black">
                            <p class="global_section_content">
                                FUTEK, a leading sensor technology giant takes the leap to cloud for a major IT
                                transformation and innovation.
                            </p>
                        </div>
                    </div>
                </a>
            </div>

            <!-- Second Case Study Card -->
            <div class="col-lg-4 col-md-6 col-sm-12 mt-30 d-flex">
                <a href="/ouropinion-casestudy" class="box-large-image__wrap wow move-up w-100"
                    aria-label="Read Ouropinion Casestudy">
                    <div class="box-large-image__box">
                        <div class="box-large-image__midea">
                            <div class="images-midea">
                                <img src="../../../assets/images/manufacture/manufacture-ouropinion.png"
                                    alt="manufacture ouropinion">
                                <div class="button-wrapper">
                                    <div class="btn tm-button">
                                        <span class="industries_button-text">Learn more</span>
                                    </div>
                                </div>
                                <div class="heading-wrap">
                                    <h3 class="heading">Our Opinions</h3>
                                </div>
                            </div>
                        </div>
                        <div class="mt-30 global_section_content">
                            <p class="global_section_content">
                                Learn how we built a futuristic application and incorporated future cloud advances into
                                our client’s IT infrastructure.
                            </p>
                        </div>
                    </div>
                </a>
            </div>

            <!-- Third Case Study Card -->
            <div class="col-lg-4 col-md-6 col-sm-12 mt-30 d-flex">
                <a routerLink="/curorc" href="/curorc" class="box-large-image__wrap wow move-up w-100"
                    aria-label="Learn more about curorc">
                    <div class="box-large-image__box">
                        <div class="box-large-image__midea">
                            <div class="images-midea">
                                <img src="../../../assets/images/manufacture/curorc.png" alt="manufacture curorc">
                                <div class="button-wrapper">
                                    <div class="btn tm-button">
                                        <span class="industries_button-text">Learn more</span>
                                    </div>
                                </div>
                                <div class="heading-wrap">
                                    <h3 class="heading">CuroRc</h3>
                                </div>
                            </div>
                        </div>
                        <div class="mt-30">
                            <p class="global_section_content">
                                Our technical experts have a flair for developing clean-coded websites based on
                                customers’ needs, global guidelines, and trends.
                            </p>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>